import React from 'react';
import HeroSection from './elements/HeroSection';
import CampsiteSection from './elements/CampsiteSection';
import InsightsSection from './elements/InsightsSection';
import { NewsSection } from './elements/NewsSection';


const HomePage: React.FC = () => {
  return (
    <div className='bg-white'>
      <HeroSection />
      <CampsiteSection />
      <InsightsSection />
      <NewsSection />
    </div>
  );
};

export default HomePage;
